import CryptoJS from "crypto-js";
import { environment } from '../environments/environment';

const SALT = environment.cryptoSalt;

export function hashUserId(userId: number) {
  try {
    return CryptoJS.SHA256(SALT + ":" + String(userId)).toString();
  } catch ( e ) {
    return '';
  }
}
